import styled from 'styled-components';

import colors from '../../../styles/colors';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
`;

export const ReviewCard = styled.div`
	text-decoration: none;
	display: flex;
	flex-direction: column;
	position: relative;
	border-bottom: 1px solid ${colors.neutralForm};
	padding: 0.75rem 0;

	@media screen and (min-width: 1400px) {
		flex-direction: row;
	}

	.review-card {
		&__card-wrapper {
			display: flex;
		}

		&__thumbnail {
			max-width: 8.375rem;
			display: flex;
			align-items: center;

			picture {
				border-radius: 0.25rem;
				border: 1px solid ${colors.neutralForm};
			}
		}

		&__info-wrapper {
			flex: 1;
			margin-left: 0.75rem;
			min-width: 12.5rem;

			&__type {
				color: ${colors.neutralText};
			}

			&__title {
				margin-top: 0.25rem;
				color: black;
				margin-right: 1rem;
			}

			&__details-wrapper {
				display: grid;
				grid-template-columns: 1fr 1fr;
				margin-top: 0.5rem;
				gap: 0.5rem;

				&__detail-item {
					display: flex;
					align-items: center;
					color: ${colors.neutralButton};

					svg {
						width: 1.25rem;
						margin-right: 0.25rem;
					}
				}
			}
		}

		&__actions-wrapper {
			display: flex;
			align-items: start;
			justify-content: flex-end;
			flex: 1;

			& > * + * {
				margin-left: 0.75rem;
			}

			@media screen and (min-width: 1400px) {
				align-items: start;
				justify-content: flex-end;
				top: 0.75rem;
				right: 0;
				margin-top: 0;
			}
		}
	}

	&:first-child {
		padding-top: 0;

		.review-card {
			&__actions-wrapper {
				top: 0;
			}
		}
	}
`;
